import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { ReactComponent as IconHead2 } from "../../../assets/icon/icon-head-2.svg"
import { Select, Spin, Empty, message } from 'antd'
import { getReportEstimatedItemSummary } from '../../../services/api/apiFFM'
import apiBarcode from '../../../services/api/apiBarcode'
import downloadCsv from '../../../components/ExportCSV/downloadCsv'

const EstimatedItemPage = () => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [data, setData] = useState([])
    const [allProductTypes, setAllProductTypes] = useState([])
    const [maxCols, setMaxCols] = useState(3)
    const timeoutRef = useRef(0)

    const fetchData = useCallback(async (productTypes = []) => {
        setLoading(true)
        setError('')

        try {
            const params = { supplier: '1C' }
            if (productTypes.length > 0) {
                params['product_types'] = productTypes
            }

            const { success, data: resData, message: mess } = await getReportEstimatedItemSummary(params)

            if (!success) {
                throw new Error(mess)
            }

            const items = Array.isArray(resData) ? resData : []
            setData(items)
        } catch (e) {
            message.error(e.message)
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        apiBarcode.getFilters()
            .then(response => {
                const { success, data, message: mess } = response.data

                if (!success) {
                    alert(mess)
                }

                setAllProductTypes(data.type || [])
            })
            .catch(e => alert(e.message))
            .finally(() => {
                fetchData()
            })
    }, [fetchData])

    useEffect(() => {
        const onResize = () => {
            let newV
            if (window.innerWidth < 700) {
                newV = 1
            } else if (window.innerWidth < 1000) {
                newV = 2
            } else {
                newV = 3
            }
            setMaxCols(newV)
        }

        window.addEventListener('resize', onResize)
        onResize()

        return () => window.removeEventListener('resize', onResize)
    }, [])

    const handleChangeProductType = (value) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)

        timeoutRef.current = setTimeout(() => {
            fetchData(value)
        }, 350)
    }

    const _handleExport = () => {
        downloadCsv(data, {
            mapCols: {
                type: 'SKU',
                quantity: 'Số lượng',
            },
            prefix: [`estimated-item-summary`].filter(Boolean).join('-') + '-',
        })
    }

    const sortedData = [...data].sort((a, b) => b.quantity - a.quantity)
    const numCols = Math.min(sortedData.length, maxCols)
    const numRows = numCols < maxCols ? 1 : Math.ceil(sortedData.length / maxCols)
    const hasData = sortedData.length > 0 && !loading

    return (
        <Row className="text-center">
            <Col md={12}>
                <div className="StaticsCreatedPage">
                    <Card>
                        <CardHeader className="CardHeader text-white header-elements-inline">
                            <h2 className="card-title d-flex align-items-center">
                                <IconHead2 />
                                Thống kê số lượng hàng hóa dự kiến
                            </h2>
                        </CardHeader>
                        <CardBody>
                            <div className="row align-items-baseline justify-content-between">
                                <Col md={6} className="FilterSku">
                                    <Select
                                        mode="multiple"
                                        placeholder="Chọn loại sản phẩm"
                                        defaultValue={[]}
                                        onChange={handleChangeProductType}
                                        allowClear={true}
                                        size="large"
                                        style={{ minWidth: '500px' }}
                                    >
                                        {allProductTypes.map(item => (
                                            <Select.Option key={item} value={item}>{item}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                                <div className="Export d-flex align-items-center pr-2">
                                    <button type="default" className='btn btn-primary' disabled={!data.length} onClick={_handleExport}>
                                        Export
                                    </button>
                                </div>
                            </div>
                            <Spin spinning={loading} tip="Loading data...">
                                {error && <p className="text-danger text-left">{error}</p>}
                                {!loading && !error && sortedData.length === 0 && <Empty description="No data" />}
                                {hasData &&
                                    <div className="TableStatics justify-content-between" data-cols={maxCols}>
                                        {Array.from({ length: maxCols }).map((_undef, colIndex) => (
                                            <div key={colIndex}>
                                                <div className="StaticsTableCreated">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="SKU text-left">SKU</th>
                                                                <th className="Quantity">Số lượng</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Array.from({ length: numRows }).map((_undef, rowIndex) => {
                                                                const item = sortedData[colIndex * numRows + rowIndex]
                                                                const { type, quantity } = { ...item }

                                                                return (
                                                                    <tr key={`${colIndex}-${rowIndex}`}>
                                                                        <td className={`SKU text-left${!type ? ' no-data' : ''}`}>
                                                                            {type || '-'}
                                                                        </td>
                                                                        <td className={`Quantity${!type ? ' no-data' : ''}`}>
                                                                            {type ? quantity : '-'}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </Spin>
                        </CardBody>
                    </Card>
                </div>
            </Col>
        </Row>
    )
}

export default EstimatedItemPage
